
const digest = '92fd11a7ed0585ef45e755f8803ccf230f1ec62abc44c1297d750b7a0ee8a517';
const css = `._dividerLine_yf9v2_1 {
  border-top: 1px solid var(--theme-secondary-border);
  margin-top: 20px;
  margin-bottom: 20px;
}

._selected_yf9v2_7 {
  border-top: 2px solid var(--aha-blue-500);
  margin-bottom: 19px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"dividerLine":"_dividerLine_yf9v2_1","selected":"_selected_yf9v2_7"};
export { css, digest };
  